
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


import "./assets/css/magnific-popup.min.css"
import "./assets/css/nouislider.css"
import "./assets/css/owl.theme.default.min.css"
import "./assets/css/ralo-blog.css"
import "./assets/css/ralo-main.css"
import "./assets/css/ralo-mobile-navbar.css"
import "./assets/css/ralo-responsive.css"
import "./assets/css/ralo-woocommerce.css"
import "./assets/css/scrollCue.css"
import "./assets/css/frontend.min.css"
import "./assets/css/post-7.css"
import "./assets/css/post-1091.css"
import "./assets/css/post-1214.css"
import '@flaticon/flaticon-uicons/css/all/all.css';

// src/main.jsx or src/index.js



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
